// extracted by mini-css-extract-plugin
export default {"input_con":"forminputStyles_input_con__-U0Y7","show_password_icon":"forminputStyles_show_password_icon__7kEy1","img_tag":"forminputStyles_img_tag__R16C+"};